/* ============================================================
   Contador de próximo despacho (FetchBall y Correlón) — hora de Colombia
   Lunes a viernes: despacho a la hora indicada (data-hora, por defecto 8:00).
   Sábado: despacho a la hora data-sabado (por defecto 7:30).
   Regla: si faltan 24 h o menos para el próximo despacho → cuenta regresiva.
   Si faltan más de 24 h → mensaje, sin cuenta regresiva:
     · Domingo de 00:00 a 08:00 (faltan 32→24 h) → [data-despacho-domingo]
     · Sábado después del despacho y sábado noche (faltan 48→32 h) → [data-despacho-finde]
   Desde el domingo 8:00 a. m. hasta el lunes 8:00 a. m. vuelve la cuenta regresiva normal.
   Marcado esperado dentro de [data-despacho]:
     [data-despacho-reloj]        → el HH:MM:SS
     [data-despacho-antes]        → texto con el reloj (se oculta en modo mensaje)
     [data-despacho-finde]        → mensaje del sábado después del despacho (hidden)
     [data-despacho-domingo]      → mensaje del domingo de madrugada (hidden)
   ============================================================ */
(function () {
  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function parseHora(txt, porDefecto) {
    var m = String(txt || '').match(/^\s*(\d{1,2})\s*[:.hH]?\s*(\d{2})?\s*$/);
    if (!m) return porDefecto;
    return { h: parseInt(m[1], 10), m: m[2] ? parseInt(m[2], 10) : 0 };
  }
  /* Fecha/hora "de pared" en Colombia (UTC-5 fijo, sin horario de verano) */
  function enColombia(ms) { return new Date(ms - 5 * 3600000); }

  function proximoDespacho(ahora, semana, sabado) {
    var co = enColombia(ahora);
    for (var add = 0; add < 9; add++) {
      var d = new Date(Date.UTC(co.getUTCFullYear(), co.getUTCMonth(), co.getUTCDate() + add));
      var dow = d.getUTCDay(); /* 0 domingo … 6 sábado */
      var hr = null;
      if (dow >= 1 && dow <= 5) hr = semana;
      else if (dow === 6) hr = sabado;
      if (!hr) continue; /* domingo: no despacha */
      var ms = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), hr.h + 5, hr.m, 0);
      if (ms > ahora) return ms;
    }
    return null;
  }

  function iniciar(caja) {
    var semana = parseHora(caja.getAttribute('data-hora'), { h: 8, m: 0 });
    var sabado = parseHora(caja.getAttribute('data-sabado'), { h: 7, m: 30 });
    var reloj = caja.querySelector('[data-despacho-reloj]');
    var antes = caja.querySelector('[data-despacho-antes]');
    var finde = caja.querySelector('[data-despacho-finde]');
    var domingo = caja.querySelector('[data-despacho-domingo]');
    if (!reloj || !antes) return;

    function tic() {
      var ahora = Date.now();
      var sig = proximoDespacho(ahora, semana, sabado);
      var dow = enColombia(ahora).getUTCDay();
      var faltan = sig ? sig - ahora : Infinity;
      /* Más de 24 h para el despacho → mensaje (domingo madrugada o sábado); si no, cuenta regresiva */
      if (faltan > 24 * 3600000) {
        var msg = (dow === 0 && domingo) ? domingo : finde;
        if (msg) {
          antes.hidden = true;
          if (finde) finde.hidden = (msg !== finde);
          if (domingo) domingo.hidden = (msg !== domingo);
          return;
        }
      }
      antes.hidden = false;
      if (finde) finde.hidden = true;
      if (domingo) domingo.hidden = true;
      var s = Math.max(0, Math.floor(faltan / 1000));
      reloj.textContent = dos(Math.floor(s / 3600)) + ':' + dos(Math.floor(s % 3600 / 60)) + ':' + dos(s % 60);
    }
    tic();
    setInterval(tic, 1000);
  }

  function arrancar() {
    var cajas = document.querySelectorAll('[data-despacho]');
    for (var i = 0; i < cajas.length; i++) iniciar(cajas[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
